import { render, staticRenderFns } from "./CardVoucher.vue?vue&type=template&id=19808350&"
import script from "./CardVoucher.vue?vue&type=script&lang=js&"
export * from "./CardVoucher.vue?vue&type=script&lang=js&"
import style0 from "./CardVoucher.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports